/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Input, Directive } from '@angular/core';
import { Renderer2, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { PulseAnimationDirective } from '../pulse-animation/pulse-animation.directive';

/**
 * #### html
 * ```
 * <div [shakeAnimation]="anObservable"></div>
 * ```
 *
 * #### component
 * ```
 * public anObservable = new Subject();
 *
 * shake(){
 * 	this.anObservable.next();
 * }
 * ```
 */

@Directive({
	selector: '[shakeAnimation]',
})
export class ShakeAnimationDirective extends PulseAnimationDirective {
	constructor(renderer: Renderer2, elementRef: ElementRef) {
		super(renderer, elementRef);
	}
	@Input() protected animationDuration = 900;
	@Input() protected animationClass = 'shake-animation';
	@Input('shakeAnimation') protected trigger$: Observable<any>;
}
